export default __webpack_public_path__ + "static/media/undyinggloryofxotli.ca3f80cc.png";